export default __webpack_public_path__ + "static/media/727.95b80390.png";